import React, { Fragment } from "react";
import { Container } from "reactstrap";
import LeftSideRibbons from "./LeftSideRibbons";
import RightSideRibbon from "./RightSideRibbon";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, RibbonsTitle } from "../../../Constants/Constants";
import AnimatedRibbons from "./AnimatedRibbons/AnimatedRibbons";

const RibbonsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={RibbonsTitle} parent={BonusUi} />
      <Container fluid>
        <LeftSideRibbons />
        <RightSideRibbon />
        <AnimatedRibbons />
      </Container>
    </Fragment>
  );
};
export default RibbonsContainer;
